import { graphql } from "react-relay";

export const createTeamAndTeamSubscriptionStripeMutation = graphql`
  mutation CreateTeamAndTeamSubscriptionStripeMutation(
    $input: CreateTeamAndTeamSubscriptionStripeInput!
  ) {
    createTeamAndTeamSubscriptionStripe(input: $input) {
      clientMutationId
      team {
        __typename
        id
        teamId
        teamName
        teamCalendarId
        createdBy {
          id
          type
          value
        }
      }
      stripeError {
        code
        message
      }
    }
  }
`;
